import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_fisk-student-hub/artifacts/60eay45i_fisk-logo-png_seeklogo-237100.png";

export default function FiskLogo({ to = "/", className = "" }) {
  return (
    <Link
      to={to}
      data-testid="fisk-logo-link"
      className={`flex items-center gap-3 select-none ${className}`}
      aria-label="FISK Centro de Ensino - Unidades Sacomã e Paulicéia"
    >
      <img
        src={LOGO_URL}
        alt="FISK Centro de Ensino"
        className="h-11 w-auto object-contain"
        draggable={false}
      />
      <div className="hidden sm:flex flex-col leading-tight border-l border-neutral-700 pl-3">
        <span className="text-[11px] font-semibold text-white tracking-wide">FISK Sacomã (SP)</span>
        <span className="text-[11px] font-semibold text-white tracking-wide">FISK Paulicéia (SBC)</span>
      </div>
    </Link>
  );
}
